/**
 * Extract plain text from TipTap JSON
 * Used for SEO, listings, breadcrumbs, etc.
 */

export const extractPlainText = (tiptapJson) => {
  if (!tiptapJson || typeof tiptapJson !== 'object') {
    return '';
  }

  // Handle doc structure
  if (tiptapJson.type === 'doc' && Array.isArray(tiptapJson.content)) {
    return tiptapJson.content.map(node => extractTextFromNode(node)).join(' ').trim();
  }

  // Handle single node
  if (tiptapJson.type && tiptapJson.content) {
    return extractTextFromNode(tiptapJson);
  }

  return '';
};

const extractTextFromNode = (node) => {
  if (!node || !node.type) return '';

  // Extract text from content array
  if (Array.isArray(node.content)) {
    return node.content.map(child => {
      if (child.type === 'text') {
        return child.text || '';
      }
      // Recursively process nested nodes
      return extractTextFromNode(child);
    }).join(' ').trim();
  }

  // Direct text node
  if (node.type === 'text') {
    return node.text || '';
  }

  return '';
};
